import styled from 'styled-components'
import { RADOM_COLORS } from '../util/Constants'

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(17, 17, 17, 0.28);
  z-index: 99;
`

export const DrawerPanel = styled.div<{ $visible: boolean }>`
  position: fixed;
  top: 0;
  right: 0;
  width: min(100%, 560px);
  height: 100%;
  background: var(--surface, #ffffff);
  box-sizing: border-box;
  box-shadow: -18px 0 48px rgba(15, 23, 42, 0.16);
  transform: ${({ $visible }) => ($visible ? 'none' : 'translateX(150%)')};
  transition: transform 0.3s ease;
  z-index: 100;
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
  border-left: 1px solid var(--border-soft, #eceff3);
`

export const DrawerInner = styled.div`
  font-size: 14px;
  width: 100%;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 24px;
  gap: 16px;
  overflow-y: auto;
`

export const DrawerHeader = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
`

export const DrawerTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`

export const DrawerEyebrow = styled.span`
  color: ${RADOM_COLORS.GRAY_DARKER};
  font-size: 12.5px;
`

export const DrawerTitle = styled.span`
  font-size: 20px;
  font-weight: 500;
  color: ${RADOM_COLORS.BLACK};
  word-break: break-word;
`

export const DrawerActions = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const DrawerMenuContent = styled.div`
  font-size: 14px;
  white-space: nowrap;
`

export const DrawerTabsWrapper = styled.div`
  margin-top: 4px;
  margin-bottom: 8px;
`

export const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FieldLabel = styled.span`
  color: ${RADOM_COLORS.NEW_GRAY_1};
`

export const FieldBox = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  padding: 11px 12px;
  border-radius: 12px;
  border: 1px solid var(--border-soft, #eceff3);
  background: var(--surface-subtle, #f9fafb);
`

export const FieldBoxValue = styled.span<{ $mono?: boolean }>`
  color: ${RADOM_COLORS.BLACK};
  font-family: ${({ $mono }) => ($mono ? 'var(--font-mono)' : undefined)};
  font-size: 13px;
  word-break: break-all;
`

export const FieldInline = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`
